var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTodayIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9285",
    "data-name": "Group 9285",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.026,
    height: 30.057,
    viewBox: "0 0 30.026 30.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4311",
    "data-name": "Path 4311",
    d: "M322.391,350.76c.85,1.034,1.641,1.929,2.35,2.885a1.229,1.229,0,0,0,1.674.459c1.1-.45,2.233-.83,3.48-1.288.24,1.381.535,2.586.63,3.806.062.788.445.96,1.082,1.052,1.213.175,2.421.387,3.757.6-.477,1.378-.94,2.589-1.294,3.831a1.3,1.3,0,0,0,.284,1.089c.938.893,1.957,1.7,3.052,2.63-1.052.869-1.979,1.674-2.95,2.423a1.023,1.023,0,0,0-.408,1.4c.477,1.135.862,2.309,1.347,3.632-1.128.2-2.154.451-3.193.54-1.131.1-1.719.554-1.8,1.742-.07,1.045-.309,2.079-.5,3.257-1.291-.479-2.424-.865-3.528-1.323a1.093,1.093,0,0,0-1.564.4c-.693.974-1.527,1.847-2.43,2.915-.82-.993-1.594-1.89-2.322-2.825-.466-.6-.873-.9-1.7-.491a34.087,34.087,0,0,1-3.453,1.288c-.227-1.264-.508-2.421-.62-3.593-.087-.915-.533-1.219-1.365-1.317-1.119-.132-2.228-.355-3.55-.573.463-1.233.844-2.361,1.312-3.452a1.17,1.17,0,0,0-.411-1.657c-.968-.705-1.862-1.513-2.894-2.364,1.03-.877,1.949-1.747,2.963-2.489a1.035,1.035,0,0,0,.393-1.477c-.358-.819-.63-1.677-.983-2.5-.329-.766-.293-1.215.708-1.282.923-.062,1.834-.3,2.756-.4a1.012,1.012,0,0,0,1.038-1.027c.11-1.023.321-2.034.467-3.054.085-.594.358-.757.923-.536.993.388,2.008.722,3,1.118a.93.93,0,0,0,1.236-.357C320.639,352.851,321.443,351.912,322.391,350.76Zm-10.244,15.014A10.26,10.26,0,1,0,322.4,355.553,10.223,10.223,0,0,0,312.147,365.774Z",
    transform: "translate(-307.382 -350.76)",
    fill: "#113252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4312",
    "data-name": "Path 4312",
    d: "M354.634,389.21a8.957,8.957,0,1,1-8.756-8.989A8.885,8.885,0,0,1,354.634,389.21Z",
    transform: "translate(-330.652 -374.128)",
    fill: "#113252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayIcon);
export default __webpack_public_path__ + "static/media/TodayIcon.f90d9ba2971d29c571787ddf6e29ccf6.svg";
export { ForwardRef as ReactComponent };